export default __webpack_public_path__ + "static/media/triangle.9caa4ac0.svg";